export const TRANSFER_CODE_LENGTH = 8;

export const normalizeTransferCode = (value = "") =>
  String(value)
    .toUpperCase()
    .replace(/[^A-Z0-9]/g, "")
    .slice(0, TRANSFER_CODE_LENGTH);

export const isCompleteTransferCode = (value) =>
  normalizeTransferCode(value).length === TRANSFER_CODE_LENGTH;

export const formatTransferCode = (code = "") =>
  `${code.slice(0, 4)} ${code.slice(4)}`.trim();

export const transferDeadline = (expiresIn, now) => now + expiresIn * 1000;

export const remainingSeconds = (deadline, now) =>
  Math.max(0, Math.ceil((deadline - now) / 1000));

export const formatRemaining = (seconds) =>
  `${Math.floor(seconds / 60)}:${String(seconds % 60).padStart(2, "0")}`;
